import { render, staticRenderFns } from "./ops-links-grid.vue?vue&type=template&id=b54782da&scoped=true"
import script from "./ops-links-grid.vue?vue&type=script&lang=js"
export * from "./ops-links-grid.vue?vue&type=script&lang=js"
import style0 from "./ops-links-grid.vue?vue&type=style&index=0&id=b54782da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54782da",
  null
  
)

export default component.exports